import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SIDE_BAR_HEADINGS } from "@faire/retailer-visitor-shared/views/settings/profile/consts";
import { MenuItem } from "@faire/retailer-visitor-shared/views/settings/profile/MenuItem";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { useMemo } from "react";
var sideBarSections = function(menuItems) {
    var _obj;
    var sections = (_obj = {}, _define_property(_obj, SIDE_BAR_HEADINGS.DEFAULT, []), _define_property(_obj, SIDE_BAR_HEADINGS.SETTINGS, []), _obj);
    menuItems.forEach(function(menuItem) {
        var _menuItem_section;
        sections[(_menuItem_section = menuItem.section) !== null && _menuItem_section !== void 0 ? _menuItem_section : SIDE_BAR_HEADINGS.DEFAULT].push(menuItem);
    });
    return sections;
};
export var SideBarRenderer = function(param) {
    var menuItems = param.menuItems, selected = param.selected;
    var sections = useMemo(function() {
        return sideBarSections(menuItems);
    }, [
        menuItems
    ]);
    return /*#__PURE__*/ _jsxs(Column, {
        "data-test-id": "side-bar-section-renderer",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subheadingSansMedium",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "j4pe1E",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Settings"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "3x"
            }),
            Object.keys(sections).map(function(section, index) {
                var items = sections[section];
                if (items.length === 0) {
                    return null;
                }
                return /*#__PURE__*/ _jsxs(Column, {
                    children: [
                        index !== 0 ? /*#__PURE__*/ _jsx(Spacer, {
                            size: "2x"
                        }) : null,
                        items.map(function(menuItem) {
                            return /*#__PURE__*/ _jsx(MenuItem, {
                                menuItem: menuItem,
                                isSelected: menuItem.value === selected
                            }, menuItem.label);
                        })
                    ]
                }, section);
            })
        ]
    });
};
